/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectPriorityDropdown_company = {
    readonly id: string;
    readonly priorityLevels: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly weight: number | null;
                readonly disabled: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "ProjectPriorityDropdown_company";
};
export type ProjectPriorityDropdown_company$data = ProjectPriorityDropdown_company;
export type ProjectPriorityDropdown_company$key = {
    readonly " $data"?: ProjectPriorityDropdown_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectPriorityDropdown_company">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPriorityDropdown_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PriorityLevelTypeConnection",
      "kind": "LinkedField",
      "name": "priorityLevels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PriorityLevelTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PriorityLevel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "disabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
})();
(node as any).hash = '43054cbacb172dc1c35fff1e7eecef0f';
export default node;
